import { isDroitsAcquis, isTsOuTcf, isTsOuTcfStatutMembreOuAutoriseASInscrire } from "@/utils/autorisationHelper";
import { Formulaire } from "@/utils/formulaire";

export const FormulaireAdmissionInitiale = new Formulaire("DemandeAdmissionInitiale", [
  { path: "RenseignementsGeneraux", name: "Renseignements" },
  { path: "AutorisationDePratique", name: "Autorisation de pratique" },
  { path: "Formations", name: "Formations" },
  { path: "Langues", name: "Langues" },
  { path: "AutresAutorisationsDePratique", name: "Autres autorisations de pratique" },
  { path: "DeclarationsObligatoires", name: "Déclarations obligatoires" },
  { path: "AttestationVeracite", name: "Attestation de véracité" },
  { path: "InformationsComplementaires", name: "Informations Complémentaires" },
]);

// PA = Personne autorisée
export const FormulaireAdmissionPA = new Formulaire("AdmissionPA", [
  { path: "RenseignementsGeneraux", name: "Renseignements" },
  { path: "AutorisationDePratique", name: "Autorisation de pratique" },
  { path: "Formations", name: "Formations" },
  { path: "Langues", name: "Langues" },
  { path: "AutresAutorisationsDePratique", name: "Autres autorisations de pratique" },
  { path: "DeclarationsObligatoires", name: "Déclarations obligatoires" },
  { path: "AttestationVeracite", name: "Attestation de véracité" },
  { path: "InformationsComplementaires", name: "Informations Complémentaires" },
]);

// todo: définir PRP
export const FormulaireAdmissionPRP = new Formulaire("DemandeAdmissionPRP", [
  { path: "RenseignementsGeneraux", name: "Renseignements" },
  { path: "AutorisationDePratique", name: "Autorisation de pratique" },
  { path: "Formations", name: "Formation universitaire" },
  { path: "Scolarite", name: "Scolarité" },
  { path: "ExperienceProfessionnelle", name: "Expérience professionnelle" },
  { path: "DeclarationsObligatoires", name: "Déclarations obligatoires" },
  { path: "NoteAdditionnelle", name: "Note additionnelle" },
]);

export const FormulaireAdmissionComplementaire = new Formulaire("DemandeAdmissionComplementaire", [
  { path: "RenseignementsGeneraux", name: "Renseignements" },
  { path: "AutorisationDePratique", name: "Autorisation de pratique" },
  { path: "Formations", name: "Formations" },
  { path: "Langues", name: "Langues" },
  { path: "AutresAutorisationsDePratique", name: "Autres autorisations de pratique" },
  { path: "DeclarationsObligatoires", name: "Déclarations obligatoires" },
  { path: "AttestationVeracite", name: "Attestation de véracité" },
  { path: "InformationsComplementaires", name: "Informations Complémentaires" },
]);

export const FormulaireReAdmission = new Formulaire("DemandeAdmissionReAdmission", [
  { path: "RenseignementsGeneraux", name: "Renseignements" },
  { path: "AutorisationDePratique", name: "Autorisation de pratique" },
  { path: "ExperienceDeTravail", name: "Expérience de travail" },
  { path: "Langues", name: "Langues" },
  { path: "AutresAutorisationsDePratique", name: "Autres autorisations de pratique" },
  { path: "DeclarationsObligatoires", name: "Déclarations obligatoires" },
  { path: "AttestationVeracite", name: "Attestation de véracité" },
  { path: "InformationsComplementaires", name: "Informations Complémentaires" },
]);

export const FormulairePremiereInscription = new Formulaire("DemandeInscriptionInitiale", [
  { path: "RenseignementsGeneraux", name: "Renseignements" },
  { path: "AutorisationDePratique", name: "Autorisation de pratique" },
  {
    path: "ActiviteReservee",
    name: "Activités réservées",
    condition: (options) => isTsOuTcfStatutMembreOuAutoriseASInscrire(options.autorisations),
  },
  { path: "DeclarationsObligatoires", name: "Déclarations obligatoires" },
  { path: "StatutEmploiEtLieuxDeTravail", name: "Statut d'emploi et lieu(x) de travail" },
  { path: "Assurance", name: "Assurance" },
  { path: "TransmissionOrdre", name: "Transmissions de renseignements à l'ordre" },
  { path: "RecapitulatifPaiement", name: "Détails relatifs au paiement" },
  { path: "AttestationVeracite", name: "Attestation et serment d'office" },
]);

export const FormulaireRenouvellement = new Formulaire("DemandeInscriptionRenouvellement", [
  { path: "RenseignementsGeneraux", name: "Renseignements" },
  { path: "AutorisationDePratique", name: "Autorisation de pratique" },
  {
    path: "ActiviteReservee",
    name: "Activités réservées",
    condition: (options) => isTsOuTcf(options.autorisations) && !isDroitsAcquis(options.autorisations),
  },
  {
    path: "DeclarationsObligatoires",
    name: "Déclarations obligatoires",
    condition: (options) => !isDroitsAcquis(options.autorisations),
  },
  { path: "StatutEmploiEtLieuxDeTravail", name: "Statut d'emploi et lieu(x) de travail" },
  {
    path: "Assurance",
    name: "Assurance",
    condition: (options) => !isDroitsAcquis(options.autorisations),
  },
  {
    path: "OptionsDePaiement",
    name: "Options de paiement",
    condition: (options) => isDroitsAcquis(options.autorisations),
  },
  {
    path: "TransmissionOrdre",
    name: "Transmissions de renseignements",
    condition: (options) => !isDroitsAcquis(options.autorisations),
  },
  { path: "RecapitulatifPaiement", name: "Détails relatifs au paiement", condition: (options) => !isDroitsAcquis(options.autorisations) },
  {
    path: "AttestationVeracite",
    name: "Attestation et serment d'office",
    condition: (options) => !isDroitsAcquis(options.autorisations),
  },
  {
    path: "AttestationVeracite",
    name: "Attestation",
    condition: (options) => isDroitsAcquis(options.autorisations),
  },
]);

export const Formulaires = [
  FormulaireAdmissionInitiale,
  FormulaireAdmissionPA,
  FormulaireAdmissionPRP,
  FormulaireAdmissionComplementaire,
  FormulaireReAdmission,
  FormulairePremiereInscription,
  FormulaireRenouvellement,
];